"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _ = require("./");

var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      url = _ref.url,
      headers = _ref.headers,
      method = _ref.method,
      query = _ref.query,
      _ref$payload = _ref.payload;

  _ref$payload = _ref$payload === void 0 ? {} : _ref$payload;
  var body = _ref$payload.body,
      params = _ref$payload.params;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$request = _ref2.request,
      mapRequest = _ref2$request === void 0 ? _ramda.identity : _ref2$request,
      _ref2$response = _ref2.response,
      mapResponse = _ref2$response === void 0 ? _ramda.identity : _ref2$response;

  var state = arguments[2];
  var onSuccess = arguments[3];
  var onError = arguments[4];
  fetch((0, _.replaceParams)(withState(url, state), params), {
    headers: withState(headers, state),
    body: mapRequest(body),
    method: method
  }).then(function (response) {
    return response.text().then(function (body) {
      return {
        response: response,
        body: mapResponse(body, response)
      };
    });
  }).then(function (_ref3) {
    var response = _ref3.response,
        body = _ref3.body;
    var meta = {
      status: response.status,
      receivedAt: Date.now()
    };

    if (response.status >= 400) {
      return onError(void 0, body, meta);
    }

    onSuccess(body, meta);
  }).catch(function (err) {
    return onError(err.message);
  });
};

exports.default = _default;

var withState = function withState(value, state) {
  return typeof value === "function" ? value(state) : value;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-server-middleware/lib/utils/fetchApi.js
// module id = 1214
// module chunks = 0